module.exports = __webpack_public_path__ + "media/images/bg-results-82d3fc01bd866494136ff04eb76016b9.jpg";